<template>
    <div id="learn-welcome">
        <div class="learn-welcome-desktop learn-0" v-if="$vuetify.breakpoint.smAndUp">
            <div class="background-learn background-welcome"></div>
            <img class="absolute decor-one" src="@/assets/images/learn/robot_475.png" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
            <div class="absolute text-welcome text-direction" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
            <div class="roboto-bold-48 clr-black" v-if="$vuetify.breakpoint.lgAndUp">Привет!</div>
            <div class="roboto-bold-36 clr-black" v-else>Привет!</div>
            <div class="roboto-normal-24 clr-black-38 mt-5" v-if="$vuetify.breakpoint.lgAndUp">
              Я помогу тебе создавать, структурировать и хранить заметки. Для начала создай раздел, в котором будут храниться заметки.
            </div>
            <div class="roboto-normal-18 clr-black-38 mt-5" v-else>
              Я помогу тебе создавать, структурировать и хранить заметки. Для начала создай раздел, в котором будут храниться заметки.
            </div>
            <div class="flex-wrap">
                <input class="input-learn mr-xl-9 mr-lg-9 mt-5" :placeholder="`Введи название (например, ${sampleName})`" v-model="themeName" :class="{sm:$vuetify.breakpoint.sm}">
                <button class="button-learn px-12 text-capitalize" @click="addTheme()" :disabled="!themeName" :class="{lgAndDown:$vuetify.breakpoint.lgAndDown}">
                  Создать
                </button>
            </div>
            </div>
            <img class="fixed decor-two-xl" width="72%"  src="@/assets/images/learn/Vector 3.png" v-if="$vuetify.breakpoint.xl">
            <img class="absolute decor-two-lg" width="72%"  src="@/assets/images/learn/Vector 3.png" v-if="$vuetify.breakpoint.lg">
            <img class="absolute decor-two-md-down" width="72%"  src="@/assets/images/learn/Vector 3.png" v-if="$vuetify.breakpoint.mdAndDown">
            <img class="fixed decor-three-xl" width="10%" src="@/assets/images/learn/Group 332.png" v-if="$vuetify.breakpoint.xl">
            <img class="absolute decor-three-lg" width="10%" src="@/assets/images/learn/Group 332.png" v-if="$vuetify.breakpoint.lg">
            <img class="absolute decor-three-md-down" width="10%" src="@/assets/images/learn/Group 332.png" v-if="$vuetify.breakpoint.mdAndDown">
            <img class="fixed decor-four-xl" width="9%" src="@/assets/images/learn/Group 329.png" v-if="$vuetify.breakpoint.xl">
            <img class="absolute decor-four-lg" width="9%" src="@/assets/images/learn/Group 329.png" v-if="$vuetify.breakpoint.lg">
            <img class="absolute decor-four-md-down" width="9%" src="@/assets/images/learn/Group 329.png" v-if="$vuetify.breakpoint.mdAndDown">
            <img class="fixed decor-five-xl" width="18%" src="@/assets/images/learn/Group 331.png" v-if="$vuetify.breakpoint.xl">
            <img class="absolute decor-five-lg" width="18%" src="@/assets/images/learn/Group 331.png" v-if="$vuetify.breakpoint.lg">
            <img class="absolute decor-five-md-down" width="18%" src="@/assets/images/learn/Group 331.png" v-if="$vuetify.breakpoint.mdAndDown">
        </div>
        <div class="learn-welcome-mobile" v-else>
            <img class="absolute decor-one" src="@/assets/images/learn/robot_528.png">
            <img class="absolute decor-two" width="100%" src="@/assets/images/learn/Vector 10.jpg">
            <div class="absolute pl-10 pr-10 text-welcome text-direction">
            <div class="roboto-bold-36 clr-black">Привет!</div>
            <div class="roboto-normal-18 clr-black-38 mt-5" width="70%">
              Я помогу тебе создавать, структурировать и хранить заметки. Для начала создай раздел, в котором будут храниться заметки.
            </div>
            <input class="input-learn input" placeholder="Введи название" v-model="themeName">
            <button class="button-learn mt-6 px-12 text-capitalize" @click="addTheme()" :class="{xs:$vuetify.breakpoint.xs}">Создать</button>
            </div>
        </div>
    </div>
</template>

<script lang='ts'>
    import { Vue } from 'vue-property-decorator'
    import { PropType } from 'vue'
    import {mapGetters, mapMutations} from 'vuex'

    export default Vue.extend({
        props: {
            // item: Object as PropType<Block>,
          sampleName: String
        },
        components: {

        },
        data() {
            return {
                themeName: '',
            }
        },
        computed: {
            ...mapGetters(['themes']),
        },
        methods: {
            ...mapMutations(['SET_CURRENT']),
            async addTheme() {
                await this.$store.dispatch('addTheme', {name: this.themeName})
                await this.$store.dispatch( "saveOrderThemes", this.themes.map(item => item._id))
                this.SET_CURRENT(this.themes[this.themes.length - 1])
                this.$router.push("/theme/" + this.themes[this.themes.length-1].route_name + "?learn=1")
            },
        },
    })

    </script>

<style lang="scss" scoped>
    $bkg-welcome: linear-gradient(180deg, #EEF8FF 0%, #DEFFEF 100%);
    $bkg-steps: rgba(87, 87, 87, 0.9);
    $clr-white: #FFFFFF;
  #learn-welcome, .background-welcome {
    background: $bkg-welcome;
    .learn-welcome-desktop {
      .decor-one {
        top:273px;
        left:14%;
        &.lg {
          left:10%
        }
        &.md {
          top:146px;
          left:11%;
          height:169px;
        }
        &.sm {
          top:146px;
          left:5%;
          height:100px;
        }
      }
      .text-welcome {
        top:281px;
        right:31%;
        width:36%;
        height:auto;
        &.lg {
          right:21%;
          width:40%;
        }
        &.md {
          top:165px;
          right:15%;
          width:45%;
        }
        &.sm {
          top:165px;
          right:25%;
          width:45%;
        }
      }
      .decor-two-xl {
        left:0%;
        bottom:0%;
      }
      .decor-two-lg {
        left:0%;
        top:845px;
      }
      .decor-two-md-down {
        left:0%;
        top:690px;
      }
      .decor-three-xl {
        bottom:12%;
        left: 6%;
      }
      .decor-three-lg {
        top: 895px;
        left: 6%;
      }
      .decor-three-md-down {
        top: 730px;
        left: 6%;
      }
      .decor-four-xl {
        bottom:25%;
        left:15%;
      }
      .decor-four-lg {
        top: 825px;
        left:15%;
      }
      .decor-four-md-down {
        top: 680px;
        left:15%;
      }
      .decor-five-xl {
        bottom:9%;
        right:9%;
      }
      .decor-five-lg {
        top:820px;
        right:9%;
      }
      .decor-five-md-down {
        top:680px;
        right:9%;
      }
    }
    .learn-welcome-mobile {
      .decor-one {
        left:17%;
        top:105px;
      }
      .text-welcome {
        top:310px;
      }
      .decor-two {
        left:0;
        top:529px;
      }
      .input {
        margin-top:140px;
        width:298px;
      }
    }
  }
</style>
